module.exports = {
  "pageView": {
    "name": "Pageview",
    "class": "view",
    "properties": {
      "screen": [
        "draft"
      ]
    },
    "namespace": "content-composer"
  },
  "compositionConverted": {
    "name": "composition-converted",
    "class": "usage",
    "properties": {
      "action": [
        "format-composition-clicked"
      ]
    },
    "namespace": "content-composer"
  },
  "compositionInteraction": {
    "name": "composition-interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "back-link-clicked"
      ]
    },
    "namespace": "content-composer"
  },
  "compositionInteractionAsUsage": {
    "name": "composition-interaction",
    "class": "usage",
    "properties": {
      "action": [
        "manage-collect",
        "click-download-collect-cta",
        "inline-bar-click",
        "format-bar-click",
        "collect-insert",
        "revert-composition",
        "question-and-answer-insert"
      ]
    },
    "namespace": "content-composer"
  },
  "compositionInteractionAsInteraction": {
    "name": "composition-interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "save-via-keyboard-shortcut",
        "paste",
        "google-docs-import",
        "format-bar-click",
        "comment-added",
        "comment-deleted"
      ]
    },
    "namespace": "content-composer"
  },
  "compositionCollaboration": {
    "name": "composition-collaboration",
    "class": "interaction",
    "properties": {
      "action": [
        "at-mention-external-user",
        "at-mention",
        "share-with-users",
        "conversation-created"
      ]
    },
    "namespace": "content-composer"
  },
  "fileManagerLib": {
    "name": "File Manager Lib",
    "class": "usage",
    "properties": {
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "componentName": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "withPanelNavigator": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-picker",
    "version": "v2"
  },
  "fileManagerSetPanelExploreFiles": {
    "name": "Explore Files",
    "class": "interaction",
    "properties": {
      "panel": "string",
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "withPanelNavigator": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-picker",
    "version": "v2"
  },
  "fileManagerExploreFiles": {
    "name": "Explore Files",
    "class": "interaction",
    "properties": {
      "fileType": {
        "isOptional": true,
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ]
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "withPanelNavigator": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-picker",
    "version": "v2"
  },
  "fileManagerImageOptimization": {
    "name": "Change image optimization setting",
    "class": "interaction",
    "properties": {
      "setting": "string",
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "withPanelNavigator": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-picker",
    "version": "v2"
  },
  "fileManagerManageFiles": {
    "name": "Manage Files",
    "class": "interaction",
    "namespace": "file-picker",
    "version": "v2",
    "properties": {
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "withPanelNavigator": {
        "type": "boolean",
        "isOptional": true
      }
    }
  },
  "fileManagerManageFolders": {
    "name": "Manage Folders",
    "class": "interaction",
    "namespace": "file-picker",
    "version": "v2",
    "properties": {
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "withPanelNavigator": {
        "type": "boolean",
        "isOptional": true
      }
    }
  },
  "fileManagerBrowseShutterstock": {
    "name": "Browse Shutterstock",
    "class": "interaction",
    "namespace": "file-picker",
    "version": "v2",
    "properties": {
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "withPanelNavigator": {
        "type": "boolean",
        "isOptional": true
      }
    }
  },
  "fileManagerAcceptVideoTOS": {
    "name": "Accept Video TOS",
    "class": "interaction",
    "properties": {
      "action": "boolean",
      "target": {
        "type": "string",
        "isOptional": true
      },
      "withPanelNavigator": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-picker",
    "version": "v2"
  },
  "fileManagerAlert": {
    "name": "Alert interaction",
    "class": "interaction",
    "namespace": "file-picker",
    "version": "v2",
    "properties": {
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "withPanelNavigator": {
        "type": "boolean",
        "isOptional": true
      }
    }
  }
};